<template>
    <div class="login-holder">
      <div class="login-box">
        <div>
          <img src="../assets/logo.png" alt="Logo" class="img-fluid logo" />
          <form @submit.prevent="validateOtp">
              <b-form-group>
                <b-form-input type="number" required @keydown="blockInvalidKeys" :state="otpState"  v-model="otp" placeholder="OTP"></b-form-input>
                <b-form-invalid-feedback v-if="otpState === false">
                  OTP must be 6 digits long.
                </b-form-invalid-feedback>
              </b-form-group>

            <div class="form-group">
              <span v-if="timeLeft > 0" class="otp-subtitle">Resend OTP in {{ timeLeft }} sec</span>
              <button v-else @click="generateOTP" type="button" style="font-size: 12px;" class="btn btn-link">Resend OTP</button>
            </div>
            <div class="form-group">
              <button  type="submit" :disabled="!otpState" class="btn btn-primary mt-5 btn-block">
                Verify OTP
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    data(){
      return {
        otp: '',
        timeLeft: 30,
        intervalId: null,
        otpState: null,
      }
    },
    created() {
      this.startTimer()
    },
    watch: {
    otp(newValue) {
      this.validateInput(newValue);
      }
    },
    methods: {
      validateInput(otp) {
        if (otp.length !== 6) {
        this.otpState = false;
      } else {
        this.otpState = true;
      }
    },
      blockInvalidKeys(event) {
      const invalidKeys = ['e', 'E', '+', '-'];
      if (invalidKeys.includes(event.key)) {
        event.preventDefault();
      }
    },
      startTimer() {
        this.timeLeft = 30;
        this.intervalId = setInterval(() => {
          this.timeLeft--;
          if (this.timeLeft <= 0) {
            clearInterval(this.intervalId);
          }
        }, 1000);
    },
    beforeDestroy() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    handleOnComplete(value) {
      this.otp = value
    },
    generateOTP() {
    this.$axios.post(`send_otp?email=${this.$route.query.email}`).then((res) => {
      this.startTimer()
        swal({
          title: "OTP sent to Register Email",
          icon: "success"
        })
    }).catch(err => {
      if (err.response.status === 500) {
        swal({
          title: "Server Error!",
          icon: "error"
        });
      } else {
        swal({
          title: "Error",
          text: err.response.data.message,
          icon: "error"
        });
      }
    })
    },

    validateOtp(){
        this.$axios.post(`verify_otp`,{
          "email": this.$route.query.email,
          "otp" : this.otp
        }).then((res)=>{
          this.$router.replace('/');

        }).catch(err => {
          this.otp = ''
            if (err.response.status === 500) {
              swal({
                title: "Server Error!",
                icon: "error"
              });
            } else {
              swal({
                title: "Error",
                text: err.response.data.message,
                icon: "error"
              });
            }
        })
      },
    }
  }
  </script>
  <style scoped>
      /* Remove spinner arrows */
      input[type="number"]::-webkit-inner-spin-button,
      input[type="number"]::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
      }
      input[type="number"] {
          -moz-appearance: textfield;
      }
  </style>